<div class="topbar">
  <div>
    <h1>Indstillinger for Installatører</h1>
  </div>
  <div class="topbar__actions">
    @if (canEdit) {
      <button class="btn-icon green" (click)="add()" matTooltip="Opret installatør">
        <mat-icon svgIcon="add"></mat-icon>
        <span>Opret installatør</span>
      </button>
    }
    <div class="search-wrap">
      <app-search [searchString]="searchQuery" label="Søg installatør på CVR el. navn"></app-search>
    </div>
  </div>
</div>
<div class="page__content settings">
  <div class="settings__wrap">
    @if (installatoerer?.length == 0 && searchQuery) {
      <div class="align-center">
        <p class="orange">
          <mat-icon svgIcon="obs-solid" class="icon-32"></mat-icon>
          <br />
          Ingen installatører fundet via søgning på "{{ searchQuery }}"
        </p>
        <div class="margin--bottom-s bold">Vil du oprette installatør?</div>
        <button mat-raised-button (click)="add()" color="primary" matTooltip="Opret installatør">Opret installatør</button>
      </div>
    }
    @if (installatoerer?.length > 0) {
      <table mat-table [dataSource]="installatoerer" class="mat-elevation-z0">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Navn</th>
          <td mat-cell *matCellDef="let installatoer">
            {{ installatoer.name }}
          </td>
        </ng-container>
        <ng-container matColumnDef="cvr">
          <th mat-header-cell *matHeaderCellDef>CVR</th>
          <td mat-cell *matCellDef="let installatoer">
            {{ installatoer.cvr }}
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell class="row-actions" *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let installatoer">
            <div class="hidden-cell">
              @if (canEdit) {
                <button
                  (click)="edit(installatoer)"
                  class="btn-icon blue"
                  aria-label="Rediger installatør"
                  matTooltip="Rediger installatør"
                  >
                  <mat-icon svgIcon="edit"></mat-icon>
                </button>
              }
              @if (canEdit) {
                <button
                  (click)="remove(installatoer)"
                  class="btn-icon red"
                  aria-label="Slet installatør"
                  matTooltip="Slet installatør"
                  >
                  <mat-icon svgIcon="delete"></mat-icon>
                </button>
              }
              <button (click)="showhistory(installatoer)" class="btn-icon blue" aria-label="Historik" matTooltip="Historik">
                <mat-icon>timeline</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    }
  </div>
</div>
<app-history-view [historyView]="historyView"></app-history-view>
